import moment from "moment/moment";
import React, { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";

const InActivePage = ({
  getResolveList,
  searchResolve,
  setresolvePage,
  resolveCount,
  listResovle,
  paginationResolve,
  rowResolve,
  type,
}) => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [update, setUpdate] = useState({});

  const handlePageChange = (selectedObject) => {
    setresolvePage(selectedObject.selected + 1);
  };

  const getView = (item) => {
    setUpdate(item);
    setModal(true);
  };

  const onClose = () => {
    setModal(false);
    setUpdate({});
  };

  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationResolve?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) => getResolveList(e.target.value, searchResolve)}
            value={rowResolve}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        <div className="mb-2">
          <input
            className="form-control bg-white"
            placeholder="Eg: Support Id"
            style={{ width: "300px" }}
            onChange={(e) => getResolveList(e.target.value, rowResolve)}
            value={searchResolve}
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Support Id</th>
              <th>User Name</th>
              <th>E-mail</th>
              <th>Mobile Number</th>
              <th>Descreption</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {listResovle?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationResolve?.current_page - 1) * rowResolve +
                      ind +
                      1}
                  </td>
                  {/* moment(item?.created_at).format("DD-MM-YYYY") */}
                  <td>{item?.support_id}</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/user", {
                          state: { data: item },
                        })
                      }
                    >
                      {item?.name}
                    </button>
                  </td>
                  <td>{item?.email}</td>
                  <td>{item?.mobile}</td>
                  <td>{item?.message}</td>
                  <td>
                    <div className="d-flex flex-column">
                      <button
                        className="cust-btn"
                        onClick={() => getView(item)}
                      >
                        <img src={viewIcon} className="edit-btn" />
                      </button>
                      <button
                        className={`${"btn-danger"} px-2 py-1 rounded-1 border-0 text-white mt-2`}
                      >
                        Resolved
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={resolveCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
      <Modal
        show={modal}
        onHide={() => {
          onClose();
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                {"Support"} View
              </label>
              <button className="cust-btn" onClick={() => onClose()}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="p-4">
            <div className="col-md-12">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                Description
              </label>
              <div>
                <div className="form-group">
                  <textarea
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    value={update?.message}
                    readOnly
                    rows={4}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                Reply Message
              </label>
              <div>
                <div className="form-group">
                  <textarea
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    value={update?.reply_message}
                    readOnly
                    rows={4}
                  />
                </div>
              </div>
            </div>
          </Row>
          <div className="text-center mb-3 mt-3">
            <button
              className={`submit-btn f2 mx-4`}
              onClick={() => {
                onClose();
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default InActivePage;
